import { FC } from "react"
import { Header, HeaderProps } from "./Header"
import { LogoutButton } from "./LogoutButton"

export const AuthenticatedHeader: FC<HeaderProps> = ({ rightButtons = LogoutButton, ...props }) => {
  return <Header {...props} />
}
